import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'RTG',
    name: 'Kopacz',
    id: 'Burrower',
    health: 80,
    difficulty: 8,
    expeditionRating: 4,
    additionalInfo: '',
  },
  {
    expansion: 'RTG',
    name: 'Żywa Twierdza',
    id: 'Fortress',
    health: 90,
    difficulty: 5,
    expeditionRating: 2,
    additionalInfo: '',
  },
]
